import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  AccordionItem,
  Accordion,
  List,
  ListItem,
  Typography,
  Icon
} from '@sm/wds-react';

import {
  getNestedItemsMobile,
  getNonNestedItemsMobile
} from '../../NavSubmenu/navSubmenuListItems';

import LogInCTA from '../../LogInCTA';
import SignUpCTA from '../../SignUpCTA';
import { MobileScreen } from '../../../..';

import './mobile-menu-anon.scss';

export const renderNestedMenuItems = item => {
  const titleClassname = classNames(
    'sm-mobile-menu__type-title',
    { 'sm-mobile-menu-anon--has-arrow-icon': !!item.alignment },
    { 'sm-mobile-menu-anon--no-subtitle': !item.subTitle }
  );
  return (
    <ListItem
      key={item.title}
      isNavigable
      navigationTarget={item.url}
      className="sm-mobile-menu__nested-item"
    >
      <Typography
        variant="sectionTitle"
        color="link"
        className={titleClassname}
      >
        {item.title}
        <If condition={item.alignment}>
          <Icon className="sm-mobile-menu__arrow-icon">]</Icon>
        </If>
      </Typography>
      {item.subTitle && (
        <p className="sm-mobile-menu-anon__type-subtitle">{item.subTitle}</p>
      )}
    </ListItem>
  );
};

const MobileMenuAnon = ({ lang, isEUDC }) => {
  const itemsData = getNestedItemsMobile(lang, isEUDC);
  const nestedMenuItems = itemsData.map(itemData => {
    const nestedItems = itemData.nestedItems.filter(item => !!item.url);
    const listItem = nestedItems.map(renderNestedMenuItems);
    return (
      <AccordionItem
        key={`${itemData}-MobileNestedItem`}
        title={itemData.title}
      >
        <List interactive transparent noRules>
          {listItem}
        </List>
      </AccordionItem>
    );
  });

  return (
    <>
      <Accordion
        noRules
        interactive
        className="sm-mobile-menu-anon"
        data-testid="MobileMenuAnon"
      >
        {nestedMenuItems}
      </Accordion>
      <List interactive className="sm-mobile-menu-anon">
        {getNonNestedItemsMobile(lang).map(item => {
          return (
            <ListItem
              key={`${item.title}-non-nested`}
              className="sm-mobile-menu-anon__anchor"
              isNavigable
              navigationTarget={item.url}
            >
              {item.title}
            </ListItem>
          );
        })}
      </List>
      <MobileScreen>
        <div className="sm-mobile-menu-anon">
          <SignUpCTA
            size="md"
            variant="solid"
            color="upgrade"
            stretched
            className="sm-mobile-menu-anon__cta"
          />
          <LogInCTA
            size="md"
            variant="solid"
            color="primary"
            stretched
            className="sm-mobile-menu-anon__cta"
          />
        </div>
      </MobileScreen>
    </>
  );
};

MobileMenuAnon.propTypes = {
  lang: PropTypes.string,
  isEUDC: PropTypes.bool
};

MobileMenuAnon.defaultProps = {
  lang: 'en',
  isEUDC: false
};

export default MobileMenuAnon;
